import { type FC } from 'react';
import { StringSmall } from '@components/Typography/Typography';
import cn from 'classnames';

import css from './styles.module.scss';

interface TimerProps {
  value: number;
  classNames?: string;
}

const InfinityTimer: FC<TimerProps> = ({ value = 0, classNames }) => {
  return (
    <div className={cn(css.infinityTimer)}>
      <StringSmall className={classNames} weight="bold">
        {value}s
      </StringSmall>
    </div>
  );
};

export { InfinityTimer };
